import { Component } from '@angular/core';

import * as $  from 'jquery';
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from '@angular/router';
import { IbRequest } from './ib-request';
import { IbResponse } from './ib-response';
import { CallBackEndService } from "./call-back-end.service";
import { SessionTimerComponent } from './session-timer/session-timer.component';
import { timerComponent } from "./cheque-book-request/timerComponent";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'Learn Angular';
  timetStart: any;

  constructor(private route : ActivatedRoute,private router: Router,private webService: CallBackEndService, private timer: SessionTimerComponent) {
    this.router.routeReuseStrategy.shouldReuseRoute = function(){
   return false;
};
   this.router.events.subscribe((evt) => {
    if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
    }
});
} 
  ngOnInit() {
    this.router.navigate(['/login'])
    // window.onpopstate = function (e) {window.location.reload();}
    window.onpopstate = function (e) { window.history.forward(); }
    $(function () {
      $(document).keydown(function (e) {
          return (e.which || e.keyCode) != 116;
      });
  });
  $(document).ready(function () {
      $(document).on("keydown", function (e) {
          e || window.event;
          if (e.ctrlKey) {
              var c = e.which || e.keyCode;
              if (c == 82) {
                  e.preventDefault();
                  e.stopPropagation();
              }
          }
      });
  });
	// this.router.navigate(['/login']);
	$(document).ready(function() {
    $('input').bind('copy paste cut',function(e) { 
    e.preventDefault(); //disable cut,copy,paste
    alert('cut,copy & paste options are disabled !!');
    });
   });

   document.addEventListener("contextmenu", function (e){
    e.preventDefault();
}, false);   
  }
 
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/app.component.ts